import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserSettingsService } from './user-setting.service';
import { safeMcpReturnUrl } from './mcp-login-return';

@Injectable({ providedIn: 'root' })
export class HttpInterceptService implements HttpInterceptor {
  constructor(
    private readonly authService: UserSettingsService,
    private readonly route: Router,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.byPassUrls(request)) {
      return next.handle(request);
    }

    if (!this.authService.validateToken()) {
      const returnUrl = safeMcpReturnUrl(this.route.url);
      if (returnUrl) this.authService.logOut(false, returnUrl);
      else this.authService.logOut(false);
    }

    if (request.headers.has('Authorization')) {
      return next.handle(request).pipe(timeout(300000 /* 30 seconds */));
    }

    return next
      .handle(
        request.clone({
          setHeaders: {
            Authorization: `Bearer ${this.authService.getToken()}`,
          },
        }),
      )
      .pipe(timeout(300000 /* 30 seconds */));
  }

  private byPassUrls(request: HttpRequest<any>) {
    const loginEndpoint = `${environment.APIEndPoint.replace(/\/$/, '')}/auth`;
    const requestUrl = request.url.split('?')[0].replace(/\/$/, '');
    const publicLoginRequest =
      (request.method === 'POST' &&
        (requestUrl === loginEndpoint ||
          requestUrl === `${loginEndpoint}/google` ||
          requestUrl === `${loginEndpoint}/microsoft`)) ||
      (request.method === 'GET' &&
        (requestUrl === `${loginEndpoint}/google/config` ||
          requestUrl === `${loginEndpoint}/microsoft/config`));

    return (
      publicLoginRequest ||
      request.url.includes('assets/') ||
      request.url.includes('/signup') ||
      request.url.includes('/sign-up') ||
      request.url.includes('.json') ||
      request.url.includes('/veritaslegalplan.com') ||
      request.url.includes('/request-otp') ||
      request.url.includes('/reset-password')
    );
  }
}
